// extracted by mini-css-extract-plugin
export default {"noDataCardContainer":"noDataCard_noDataCardContainer__USv-I"};